import React from "react";

import CustomInput from "../common/CustomInput";
import { getIcons, getLogos } from "../Constant/Constant";
import useLogin from "../hooks/useLogin";
import { ToastContainer } from "react-toastify";

const Login = () => {
  const logos = getLogos();
  const images = getIcons();

  const {
    email,
    password,
    isLoading,
    formErrors,
    handleEmailChange,
    handlePasswordChange,
    handleLogin,
    navigate,
  } = useLogin();

  return (
    <>
<ToastContainer/>

      <div className="grid grid-cols-2 w-full overflow-hidden">
        {/* Left side - Image */}
        <div className="w-full h-screen bg-gradient-to-b from-[#399C7A] to-[#14362A] flex items-center justify-center">
          <img src={images.loginImage} alt="Login" />
        </div>

        {/* Right side - Login form */}
        <div className="w-full bg-slate-100 flex justify-center">
          <div className="absolute right-4">
            <img className="p-5 w-36" src={logos.clientLoginLogo} alt="Logo" />
          </div>

          <div className="mt-52 mx-56 3xl:mt-64 2xl:mt-56 xl:mt-56 lg:mt-36 4xl:mt-21 relative">
            <form className="flex flex-col gap-3" onSubmit={handleLogin}>
              <h1 className="font-bold 2xl:text-2xl lg:text-xl 3xl:text-3xl 4xl:text-4xl">
                Hi, Happy to see you here.
              </h1>

              <label
                className="font-normal text-xl lg:text-lg 3xl:text-2xl 4xl:text-3xl"
                htmlFor="email"
              >
                Login
              </label>

              <CustomInput
                name="email"
                type="text"
                value={email}
                onChange={handleEmailChange}
                placeholder="Enter your email"
              />

              <label
                className="text-xl lg:text-lg 3xl:text-2xl 4xl:text-3xl"
                htmlFor="password"
              >
                Password
              </label>

              <CustomInput
                name="password"
                type="password"
                value={password}
                onChange={handlePasswordChange}
                placeholder="Enter your password"
              />

              <br />

              <button
                type="submit"
                disabled={!email || !password || isLoading}
                className={`
    text-center text-lg 3xl:text-xl text-white rounded-md shadow
    3xl:w-[530px] 3xl:h-12 4xl:w-[630px] 4xl:h-16 xl:w-[398px]
    custom-xl:w-[398px] 2xl:w-[398px] lg:w-72 h-10
    ${
      !email|| !password || isLoading
        ? "bg-gray-400 cursor-not-allowed"
        : "bg-customGreen hover:bg-green-600"
    }
  `}
              >
                Login
              </button>

              <div
                className="text-[#007AFF] w-full flex justify-end cursor-pointer text-lg lg:text-sm xl:text-lg custom-xl:text-lg 4xl:text-2xl 3xl:text-lg"
                onClick={() => navigate("/reset-password")}
              >
                Forgot password?
              </div>

              {formErrors.general && (
                <p className="text-red-500 text-center text-sm">
                  {formErrors.general}
                </p>
              )}
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
